<script setup lang="ts">
import * as zagRadio from "@zag-js/radio-group";
import { normalizeProps, useMachine } from "@zag-js/vue";
import { computed } from "vue";
import { SvgIcon } from "../";

const emit = defineEmits(["update:modelValue"]);
interface NewType {
	label?: string;
	name?: string;
	modelValue: string;
}

const { modelValue } = defineProps<NewType>();

const options: string[] = ["1", "2", "3", "4", "5"];

const [state, send] = useMachine(
	zagRadio.machine({
		id: (Math.random() + 1).toString(36).substring(7),
		value: modelValue,
		onValueChange: ({ value }) => emit("update:modelValue", value)
	})
);

const api = computed(() => zagRadio.connect(state.value, send, normalizeProps));
</script>

<template>
	<div class="flex flex-col w-full gap-y-2">
		<label v-if="label" :for="name" class="text-base text-black-light font-medium">
			{{ label }}
		</label>
		<div v-bind="api.rootProps" :id="name" class="flex gap-2">
			<div v-for="option in options" :key="option">
				<label
					v-bind="api.getItemProps({ value: option })"
					class="flex gap-2 items-center cursor-pointer w-fit"
				>
					<span
						v-bind="api.getItemTextProps({ value: option })"
						class="p-2 bg-white rounded border border-brown"
					>
						<SvgIcon
							name="star"
							class="w-5 h-5 stroke-2"
							:class="[
								api.value === option || (api.value && +api.value > +option)
									? 'text-[#FFA755] stroke-[#FFA755]'
									: 'text-white stroke-black-light'
							]"
						/>
					</span>
					<input v-bind="api.getItemHiddenInputProps({ value: option })" :name="name" />
					<div v-bind="api.getItemControlProps({ value: option })" />
				</label>
			</div>
		</div>
	</div>
</template>
